import React from 'react';

/**
 * Brand mark — vermillion 加 stamp, no wordmark. The domain is the
 * wordmark (it lives in the URL bar, page title, and email From line).
 */
function Brand({ size = 'md', inverse = false, stampChar = '加' }) {
  const stampSize = size === 'lg' ? 44 : size === 'sm' ? 24 : 32;
  const stampFont = size === 'lg' ? 22 : size === 'sm' ? 13 : 17;

  return (
    <span
      className="stamp"
      style={{
        width: stampSize,
        height: stampSize,
        fontSize: stampFont,
        background: inverse ? 'var(--paper)' : 'var(--vermillion)',
        color: inverse ? 'var(--vermillion)' : '#fff',
      }}
    >
      {stampChar}
    </span>
  );
}

export default Brand;
